import { applyMiddleware, compose, createStore, combineReducers } from 'redux';
import reducers from '../reducers';
import middlewares from '../middlewares';
import { createReduxHistoryContext } from 'redux-first-history';
import { createBrowserHistory } from 'history';
import * as Sentry from '@sentry/react';

const {
  createReduxHistory,
  routerMiddleware,
  routerReducer,
} = createReduxHistoryContext({
  history: createBrowserHistory(),
});

const sentryReduxEnhancer = Sentry.createReduxEnhancer({});

export default function configureStore(initialState) {
  const composedMiddleware = compose(
    applyMiddleware(routerMiddleware, ...middlewares),
    sentryReduxEnhancer
  );
  const store = createStore(
    combineReducers({
      router: routerReducer,
      ...reducers,
    }),
    initialState,
    composedMiddleware
  );

  if (process.env.NODE_ENV !== 'production' && module.hot) {
    module.hot.accept('../reducers', () => {
      const nextRootReducer = require('../reducers/index');

      store.replaceReducer(nextRootReducer);
    });
  }

  let history = createReduxHistory(store);

  return { store, history };
}
